import { withScopeContext } from '@mews/framework';
import { connectAccountItemAssignmentDialog, connectGroupItemAssignmentDialog } from './connectItemAssignmentDialog';
import { ItemAssignmentDialog } from './ItemAssignmentDialog';

export const GroupItemAssignmentDialog = withScopeContext(connectGroupItemAssignmentDialog(ItemAssignmentDialog));

export const AccountItemAssignmentDialog = withScopeContext(connectAccountItemAssignmentDialog(ItemAssignmentDialog));
